import * as React from 'react'
import { useScimStyles } from './scimShared'

export const ScimLoadingView: React.FC = () => {
  const styles = useScimStyles()
  return (
    <>
      <div className={styles.skeletonBar} style={{ width: '100%' }} />
      <div className={styles.skeletonBar} style={{ width: '85%' }} />
      <div className={styles.skeletonBar} style={{ width: '60%' }} />
    </>
  )
}
